import React from "react";
import { styled } from "@mui/system";
import { Box, Drawer, List, ListItem, MenuItem } from "@mui/material";

const MainContainer = styled(Drawer)({
  minWidth: "300px",
  width: "300px",
  textAlign: "left",
});

const Heading = styled("p")({
  color: "black",
  fontWeight: "bold",
  fontSize: "14px",
  paddingLeft: "16px",
});

const CategoryItem = styled(MenuItem)(({ selected }) => ({
  color: selected && "#2196F3",
  fontWeight: selected && "bold",
  fontSize: "14px",
}));

/**
 *
 * @param {Boolean} open Open/Closed state of the drawer
 * @param {Function} closeCategories Closes the drawer
 * @param {Function} changeCategory Changes the category selected
 * @param {Number} currentCategory Current categoryID selected
 * @param {Array} categories - All the categories available
 * @returns Category select menu for mobile responsive width (650px)
 */
const CategorySelectMobile = ({
  changeCategory,
  currentCategory,
  categories,
  open,
  closeCategories,
}) => {
  const handleCategoryClick = (e) => {
    const { myValue } = e.currentTarget.dataset;
    changeCategory(parseInt(myValue));
    closeCategories();
  };

  return (
    <MainContainer open={open} anchor="left" onClose={closeCategories}>
      <Box minWidth={200}>
        <Heading>Categories</Heading>
        <List>
          <CategoryItem
            selected={0 === currentCategory}
            data-my-value={0}
            onClick={handleCategoryClick}
            button
            key="All"
          >
            All
          </CategoryItem>
          {categories.map(({ displayName, categoryId }) => (
            <CategoryItem
              selected={categoryId === currentCategory}
              data-my-value={categoryId}
              onClick={handleCategoryClick}
              key={displayName}
            >
              {displayName}
            </CategoryItem>
          ))}
        </List>
      </Box>
    </MainContainer>
  );
};

export default CategorySelectMobile;
